export const getDeliveryStatus = (deliveryStatus) => ({
  draft: deliveryStatus === 'draft',
  review: deliveryStatus === 'in review',
  rejected: deliveryStatus === 'rejected',
  scheduled: deliveryStatus === 'scheduled',
  live: deliveryStatus === 'active',
});
